/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

const buildQuery = (params = {}) => {
    const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
        acc[k] = Array.isArray(v) ? v.join(',') : v;
        return acc;
    }, {});
    const qs = new URLSearchParams(cleaned).toString();
    return qs ? `?${qs}` : '';
};

export default {
    getAll: async (params) => exeRequest(`/admin/types-assurance${buildQuery(params)}`, "GET"),

    getById: async (id) => exeRequest(`/admin/types-assurance/${id}`, "GET"),

    create: async (data) => exeRequest(`/admin/types-assurance`, "POST", data),

    update: async (id, data) => exeRequest(`/admin/types-assurance/${id}`, "PUT", data),

    delete: async (id) => exeRequest(`/admin/types-assurance/${id}`, "DELETE"),

    toggle: async (id, isActive) => exeRequest(`/admin/types-assurance/${id}/toggle`, "PATCH", { isActive }),
};
